import { render } from "./ManageSearchView.vue?vue&type=template&id=56e3bc17"
import script from "./ManageSearchView.vue?vue&type=script&lang=js"
export * from "./ManageSearchView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__